import React from "react"
import styled from "styled-components"
import { HeadingTwo } from "buoy-core"
import { responsive } from "buoy-theme"

const welcomeConfig = profile => {
  if (profile && profile.first_name) {
    return {
      heading: `Welcome back, ${profile.first_name}!`,
      tagline: "With you, from sickness to health",
    }
  } else if (profile) {
    return {
      heading: "Welcome back!",
      tagline: "With you, from sickness to health",
    }
  } else {
    return {
      heading: "Get back to well.",
      tagline: "Check symptoms. Find care. Get better.",
    }
  }
}

const Heading = styled(HeadingTwo)`
  width: 100%;
  max-width: none;
  font-size: 72px;
  font-weight: 300;
  letter-spacing: -0.2px;
  text-align: left;
  ${responsive("font-size", "72px", "72px", "42px", "42px", "42px")};
  ${responsive("line-height", "76px", "76px", "48px", "48px", "48px")};
  ${responsive("margin-bottom", "18px", "18px", "12px", "12px", "12px")};
  margin-top: -12px;
`
// Note we can get rid of the weight and spacing rules w/ newest common component (v5s) updates
const Tagline = styled.h4`
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.2px;
  margin: 0;
`

const WelcomeWrapper = styled.div`
  flex: 1;
  margin-bottom: 40px;
  ${responsive("margin-bottom", "40px", "40px", "48px", "48px", "48px")};
`

const Welcome = ({ profile, mobile }) => (
  <WelcomeWrapper mobile={mobile}>
    <Heading>{welcomeConfig(profile).heading}</Heading>
    <Tagline>{welcomeConfig(profile).tagline}</Tagline>
  </WelcomeWrapper>
)

export default Welcome



// WEBPACK FOOTER //
// ./assets/dashboard/components/Welcome.js